// Términos y Condiciones - Terms of Service
import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPages.css';

const Terms = () => {
    return (
        <div className="legal-container">
            <nav className="legal-nav">
                <Link to="/" className="legal-back">← Volver al inicio</Link>
                <Link to="/" className="legal-logo">
                    <div className="legal-logo-icon">⚡</div>
                    <span className="legal-logo-text">Roadmap<span>Platform</span></span>
                </Link>
            </nav>

            <header className="legal-header">
                <h1>Términos y Condiciones</h1>
                <p className="legal-subtitle">Condiciones de uso del servicio Roadmap Platform</p>
                <span className="legal-updated">Última actualización: Febrero 2026</span>
            </header>

            <main className="legal-content">
                <section className="legal-section">
                    <h2>1. Aceptación de los términos</h2>
                    <p>Al acceder y utilizar Roadmap Platform (en adelante, "el Servicio"), usted acepta estar vinculado por estos Términos y Condiciones. Si no está de acuerdo con alguna parte de estos términos, no podrá acceder al Servicio.</p>
                    
                    <div className="legal-info-box important">
                        <p><strong>Importante:</strong> Debe tener al menos 16 años de edad para utilizar este Servicio. Al utilizar el Servicio, declara que tiene al menos 16 años.</p>
                    </div>
                </section>

                <section className="legal-section">
                    <h2>2. Descripción del servicio</h2>
                    <p>Roadmap Platform es una herramienta de gestión de proyectos que permite:</p>
                    <ul>
                        <li>Crear y gestionar roadmaps de desarrollo de software</li>
                        <li>Organizar tareas, fases y dependencias</li>
                        <li>Integrar con servicios de terceros (GitHub, Supabase, Vercel)</li>
                        <li>Almacenar de forma segura credenciales y configuraciones</li>
                        <li>Realizar backups automáticos de proyectos</li>
                        <li>Acceder a guías de aprendizaje para principiantes</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>3. Registro y cuenta</h2>
                    
                    <h3>3.1 Creación de cuenta</h3>
                    <p>Para utilizar el Servicio, debe crear una cuenta utilizando GitHub como proveedor de autenticación. Usted es responsable de:</p>
                    <ul>
                        <li>Mantener la seguridad de su cuenta de GitHub</li>
                        <li>Todas las actividades que ocurran bajo su cuenta</li>
                        <li>Notificarnos inmediatamente cualquier uso no autorizado</li>
                    </ul>

                    <h3>3.2 Datos de la cuenta</h3>
                    <p>Al conectar su cuenta de GitHub, nos autoriza a acceder a cierta información de su perfil público. No almacenamos su contraseña de GitHub ni tenemos acceso a ella.</p>
                </section>

                <section className="legal-section">
                    <h2>4. Planes y precios</h2>
                    
                    <h3>4.1 Suscripción de pago</h3>
                    <p>El acceso al Servicio es de pago desde el primer día. No existe periodo de prueba gratuito. Los planes vigentes son:</p>
                    <ul>
                        <li><strong>Basic:</strong> 4,99 €/mes (o 56,99 €/año con 5% de descuento). Un proyecto, un usuario.</li>
                        <li><strong>Pro:</strong> 14,99 €/mes (o 170,99 €/año con 5% de descuento). Proyectos ilimitados, hasta 10 usuarios por proyecto.</li>
                    </ul>
                    <p>El pago se procesa mediante pasarela segura (Stripe o equivalente). Los precios se entienden en euros (€) e IVA incluido cuando sea de aplicación.</p>

                    <h3>4.2 Renovación y cancelación</h3>
                    <ul>
                        <li>Las suscripciones se renuevan automáticamente (mensual o anual según la modalidad elegida).</li>
                        <li>Puede cancelar en cualquier momento desde el panel de configuración (Dashboard → Configuración → Suscripción).</li>
                        <li>La cancelación será efectiva al final del periodo de facturación ya pagado; no hay reembolso por la parte no consumida.</li>
                        <li>No se realizan reembolsos por periodos parciales ni por cambio de opinión una vez contratado.</li>
                    </ul>

                    <h3>4.3 Cambios de precio</h3>
                    <p>Nos reservamos el derecho de modificar los precios. Los cambios se comunicarán con al menos 30 días de antelación por email o aviso en el Servicio. El uso continuado tras la entrada en vigor del nuevo precio constituye aceptación del mismo.</p>
                </section>

                <section className="legal-section">
                    <h2>5. Uso aceptable</h2>
                    
                    <h3>5.1 Usos permitidos</h3>
                    <p>El Servicio está diseñado para la gestión legítima de proyectos de desarrollo de software. Puede utilizarlo para proyectos personales, educativos o comerciales.</p>

                    <h3>5.2 Usos prohibidos</h3>
                    <p>Está prohibido utilizar el Servicio para:</p>
                    <ul>
                        <li>Actividades ilegales o fraudulentas</li>
                        <li>Almacenar contenido ilegal, difamatorio o que viole derechos de terceros</li>
                        <li>Intentar acceder a cuentas de otros usuarios</li>
                        <li>Realizar ingeniería inversa o intentar extraer el código fuente</li>
                        <li>Sobrecargar, dañar o deshabilitar el Servicio</li>
                        <li>Utilizar bots o scripts automatizados sin autorización</li>
                        <li>Revender o redistribuir el Servicio sin autorización</li>
                    </ul>

                    <div className="legal-info-box warning">
                        <p><strong>Advertencia:</strong> El incumplimiento de estas normas puede resultar en la suspensión o terminación inmediata de su cuenta sin reembolso.</p>
                    </div>
                </section>

                <section className="legal-section">
                    <h2>6. Propiedad del contenido</h2>
                    
                    <h3>6.1 Su contenido</h3>
                    <p>Usted conserva todos los derechos sobre el contenido que crea, sube o almacena en el Servicio, incluyendo:</p>
                    <ul>
                        <li>Proyectos y roadmaps</li>
                        <li>Código fuente de sus proyectos</li>
                        <li>Configuraciones y datos</li>
                    </ul>
                    <p>Al utilizar el Servicio, nos otorga una licencia limitada para almacenar, procesar y mostrar su contenido únicamente con el fin de proporcionar el Servicio.</p>

                    <h3>6.2 Nuestro contenido</h3>
                    <p>El Servicio, incluyendo su diseño, código, funcionalidades, marcas y logotipos, es propiedad de Roadmap Platform y está protegido por leyes de propiedad intelectual.</p>
                </section>

                <section className="legal-section">
                    <h2>7. Privacidad y seguridad de datos</h2>
                    
                    <h3>7.1 Tratamiento de datos</h3>
                    <p>El tratamiento de sus datos personales se rige por nuestra <Link to="/privacy-policy">Política de Privacidad</Link>, que forma parte integral de estos términos.</p>

                    <h3>7.2 Credenciales de terceros</h3>
                    <p>Cuando almacena credenciales de servicios externos (API keys de Supabase, tokens de GitHub, etc.) en nuestro Vault:</p>
                    <ul>
                        <li>Las credenciales se cifran con encriptación AES-256 antes de almacenarse</li>
                        <li>Solo usted puede acceder a sus credenciales descifradas</li>
                        <li>Nunca compartimos sus credenciales con terceros</li>
                        <li>Puede eliminar sus credenciales en cualquier momento</li>
                    </ul>

                    <div className="legal-info-box">
                        <p><strong>Nota de seguridad:</strong> Aunque implementamos medidas de seguridad robustas, le recomendamos no almacenar credenciales de producción críticas. Utilice el Vault principalmente para proyectos de desarrollo.</p>
                    </div>
                </section>

                <section className="legal-section">
                    <h2>8. Integraciones con terceros</h2>
                    <p>El Servicio se integra con plataformas de terceros como GitHub, Supabase y Vercel. Cuando utiliza estas integraciones:</p>
                    <ul>
                        <li>Debe cumplir también con los términos de servicio de esas plataformas</li>
                        <li>No somos responsables del funcionamiento de esos servicios externos</li>
                        <li>Puede desconectar las integraciones en cualquier momento</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>9. Disponibilidad del servicio</h2>
                    <p>Nos esforzamos por mantener el Servicio disponible 24/7, pero no garantizamos una disponibilidad ininterrumpida. Pueden ocurrir interrupciones por:</p>
                    <ul>
                        <li>Mantenimiento programado (notificado con antelación cuando sea posible)</li>
                        <li>Actualizaciones de seguridad urgentes</li>
                        <li>Circunstancias fuera de nuestro control</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>10. Limitación de responsabilidad</h2>
                    <p>En la máxima medida permitida por la ley:</p>
                    <ul>
                        <li>El Servicio se proporciona "tal cual" sin garantías de ningún tipo</li>
                        <li>No garantizamos que el Servicio sea libre de errores o virus</li>
                        <li>No seremos responsables de daños indirectos, incidentales o consecuentes</li>
                        <li>Nuestra responsabilidad total no excederá el importe pagado por usted en los últimos 12 meses</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>11. Indemnización</h2>
                    <p>Usted acepta indemnizar y mantener indemne a Roadmap Platform, sus directivos, empleados y agentes, frente a cualquier reclamación, daño, pérdida o gasto derivado de:</p>
                    <ul>
                        <li>Su uso del Servicio</li>
                        <li>Su violación de estos términos</li>
                        <li>Su violación de derechos de terceros</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>12. Terminación</h2>
                    
                    <h3>12.1 Por usted</h3>
                    <p>Puede cancelar su cuenta en cualquier momento desde el panel de configuración. Tras la cancelación:</p>
                    <ul>
                        <li>Perderá acceso al Servicio</li>
                        <li>Sus datos se conservarán durante 30 días por si desea reactivar</li>
                        <li>Puede solicitar la eliminación inmediata de sus datos</li>
                    </ul>

                    <h3>12.2 Por nosotros</h3>
                    <p>Podemos suspender o terminar su cuenta si:</p>
                    <ul>
                        <li>Viola estos términos</li>
                        <li>Realiza actividades fraudulentas</li>
                        <li>No paga la suscripción tras múltiples intentos</li>
                    </ul>
                </section>

                <section className="legal-section">
                    <h2>13. Modificaciones de los términos</h2>
                    <p>Podemos modificar estos términos en cualquier momento. Le notificaremos los cambios significativos por email o mediante un aviso en el Servicio. El uso continuado del Servicio tras los cambios constituye su aceptación de los nuevos términos.</p>
                </section>

                <section className="legal-section">
                    <h2>14. Ley aplicable y jurisdicción</h2>
                    <p>Estos términos se rigen por la legislación española. Para cualquier controversia, las partes se someten a los Juzgados y Tribunales del domicilio del usuario en España.</p>
                </section>

                <section className="legal-section">
                    <h2>15. Contacto</h2>
                    <p>Para cualquier consulta sobre estos Términos y Condiciones:</p>
                    <ul>
                        <li>Página de contacto: <Link to="/contact">roadmap.fixarr.es/contact</Link></li>
                        <li>Email legal y soporte: <a href="mailto:legal@roadmap.fixarr.es">legal@roadmap.fixarr.es</a></li>
                    </ul>
                </section>
            </main>

            <footer className="legal-footer">
                <div className="legal-footer-links">
                    <Link to="/legal">Aviso Legal</Link>
                    <Link to="/privacy-policy">Política de Privacidad</Link>
                    <Link to="/cookies">Política de Cookies</Link>
                    <Link to="/contact">Contacto</Link>
                </div>
                <p>© 2026 Roadmap Platform. Parte del ecosistema FIXARR.</p>
            </footer>
        </div>
    );
};

export default Terms;
